import * as readApi from './read';
import * as writeApi from './write';

export const read = readApi;
export const write = writeApi;


